import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Message from './Message';
var MessageList = function (_a) {
    var messages = _a.messages, loading = _a.loading, goToBottom = _a.goToBottom;
    var scrollDivRef = useRef(null);
    useEffect(function () {
        if (goToBottom) {
            scrollToBottom();
        }
    }, [messages, goToBottom]);
    var scrollToBottom = function () {
        if (scrollDivRef.current) {
            scrollDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
    };
    var handleScrollToBottomClick = function () { return scrollToBottom(); };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { position: "fixed", right: 0, bottom: 0, pb: 25, pr: 2, zIndex: 2, children: _jsx(Fab, { size: "small", onClick: handleScrollToBottomClick, children: _jsx(ArrowDownwardIcon, {}) }) }), _jsxs(Stack, { zIndex: 1, divider: _jsx(Divider, { sx: { width: '100%' } }), width: "100%", flexGrow: 1, flexShrink: 1, alignItems: "center", minHeight: 0, sx: { overflowY: 'auto' }, children: [messages.map(function (message) { return (_jsx(Message, { message: message }, message.id)); }), _jsx(Box, { ref: scrollDivRef, children: loading && (_jsx(Box, { pt: 2, pb: 2, children: _jsx(CircularProgress, {}) })) })] })] }));
};
export default MessageList;
